import { render, staticRenderFns } from "./FrontExperiencePage.vue?vue&type=template&id=161cd1d6&scoped=true"
import script from "./FrontExperiencePage.vue?vue&type=script&lang=js"
export * from "./FrontExperiencePage.vue?vue&type=script&lang=js"
import style0 from "./FrontExperiencePage.vue?vue&type=style&index=0&id=161cd1d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161cd1d6",
  null
  
)

export default component.exports